import styled from 'styled-components';
import userRound from '~/assets/icons/user_round.svg';
import { Text } from '~/components/ui/Text';
import arrowFines from '../../assets/images/arrow_fines.svg';

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledUserPic = styled.div`
	width: 40px;
	height: 40px;
	background-image: url(${userRound});
`;

const StyledInfoContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 20px;
`;

const StyledExpensesContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100px;
	padding: 20px;
	border-radius: 10px;
	background: rgba(255, 255, 255, 0.02);

	& > ${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledInfoValue = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledFinesContainer = styled(StyledExpensesContainer)`
	position: relative;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	cursor: pointer;
`;

const StyledFinesArrow = styled.div`
	position: absolute;
	top: 20px;
	right: 20px;
	width: 21px;
	height: 16px;
	background-image: url(${arrowFines});
	opacity: 0.5;
`;

const StyledCardsContainer = styled.div`
	margin-top: 20px;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 20px;
	margin-top: 20px;
`;

const StyledButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 70px;
	height: 70px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}
`;

const StyledButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	cursor: pointer;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}

	&:hover {
		${Text} {
			opacity: 1;
		}

		${StyledButton} {
			background-color: #ffffff;

			img {
				filter: invert(1);
			}
		}
	}
`;

export {
	StyledButton,
	StyledButtonContainer,
	StyledButtonsContainer,
	StyledCardsContainer,
	StyledExpensesContainer,
	StyledFinesArrow,
	StyledFinesContainer,
	StyledHead,
	StyledInfoContainer,
	StyledInfoValue,
	StyledUserPic,
};
